export default "__VITE_ASSET__Dn02ffgy__"